import { signal } from '@angular/core';
import { QueuedNotification } from './types';

const _queue = signal<QueuedNotification[]>([]);

export const notificationQueue = _queue.asReadonly();

export const queueActions = {
  enqueue: (item: QueuedNotification) => _queue.update((q) => [...q, item]),
  dequeue: () => _queue.update(([_, ...rest]) => rest),
};
